import axios from 'axios'
import auth from './auth'

const hubUrl = process.env.VUE_APP_HUB_URL

const params = new URLSearchParams({
  'filter[module]': 'BI',
  'filter[component]': 'bi-filters'
})

const getAllSavedFilters = () => axios
  .get(`${hubUrl}/system-preferences`, {
    params: params,
    headers: {
      'X-Auth-Token': auth.getAuthToken()
    }
  })
  .then(response => {
    return response.data
  })

const createFilter = (requestPayload) => axios
  .post(`${hubUrl}/system-preferences`, requestPayload, {
    headers: {
      'X-Auth-Token': auth.getAuthToken(),
      'Content-Type': 'application/vnd.api+json'
    }
  })

const updateFilter = (id, requestPayload) => axios
  .put(`${hubUrl}/system-preferences/${id}`, requestPayload, {
    headers: {
      'X-Auth-Token': auth.getAuthToken(),
      'Content-Type': 'application/vnd.api+json'
    }
  })

const deleteFilter = (id) => axios
  .delete(`${hubUrl}/system-preferences/${id}`, {
    headers: {
      'X-Auth-Token': auth.getAuthToken()
    }
  })

export default {
  getAllSavedFilters,
  createFilter,
  updateFilter,
  deleteFilter
}
